import { Grid, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import ReactPlayer from 'react-player';

import theme, { useCommonStyles } from '../../root/theme';
import { mobileBreakpoint } from './joinTheRevolutionSection';

const COURSE_OVERVIEW_VIDEO_URL = 'https://mrazek.wistia.com/medias/65vn2s1dck';

const useStyles = makeStyles((theme: Theme) => {
  return {
    sectionHeight: {
      paddingTop: 120,
      paddingBottom: 120,
      paddingLeft: 20,
      paddingRight: 20,
      [theme.breakpoints.down('sm')]: {
        paddingTop: 100,
        paddingBottom: 100,
      },
    },
    headerContainer: {
      textAlign: 'center',
      maxWidth: '800px',
      width: '100%',
    },
    header: {
      [theme.breakpoints.down('xs')]: {
        fontSize: '28px',
        letterSpacing: '.65px',
        lineHeight: '32px',
      },
    },
    video: {
      paddingTop: 40,
      paddingBottom: 30,
    },
  };
});

const CourseOverviewSection: React.FC = () => {
  const classes = useStyles({});
  const commonClasses = useCommonStyles({});
  const isScreenSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const isScreenXSmall = useMediaQuery(theme.breakpoints.down('xs'));
  const isScreenMobile = useMediaQuery(
    theme.breakpoints.down(mobileBreakpoint)
  );

  return (
    <Grid
      container
      className={clsx(classes.sectionHeight, commonClasses.flexCenterContents)}
    >
      <Grid item md={10} className={classes.headerContainer}>
        <Typography variant="h3" color="textPrimary" className={classes.header}>
          Learn how we help students train their attention and improve their
          mental health
        </Typography>
      </Grid>
      <Grid
        item
        md={10}
        className={clsx(classes.video, commonClasses.flexCenterContents)}
      >
        <ReactPlayer
          url={COURSE_OVERVIEW_VIDEO_URL}
          width={
            isScreenMobile
              ? 340
              : isScreenXSmall
              ? 444
              : isScreenSmall
              ? 618
              : 796
          }
          height={
            isScreenMobile
              ? 190
              : isScreenXSmall
              ? 250
              : isScreenSmall
              ? 350
              : 450
          }
        />
      </Grid>
    </Grid>
  );
};

export default CourseOverviewSection;
